<template>
  <!-- 积分商城-礼品列表 -->
  <div class="gift_list">
    <!-- 头部表单查询 -->
    <input-form :inputData="inputData" @toParentVal="searchForm" :pageName="pageName" :btnPosition1="true"></input-form>

    <!-- 表格内容 -->
    <el-table
      v-loading="talbeLoading"
      :data="tableData"
      style="width: 100%; margintop: 20px"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <template slot="empty">
        <div>
          <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column label="礼品名称" width="250">
        <template slot-scope="scope">
          <div class="activityName">
            <el-popover placement="top-start" width="400" trigger="hover">
              <p style="margin: 20px">
                请用手机京东扫描下面二维码查看您店铺的活动详情
              </p>
              <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
              <div :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div>
              <div>
                <p style="margin: 20px">
                  链接地址：(手机京东店铺中活动详情链接地址)
                </p>
                <el-input v-model="scope.row.idUrl" style="margin: 0 20px; width: 220px"></el-input
                ><el-button type="primary" v-clipboard:copy="scope.row.idUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
                  >复制</el-button
                >
              </div>
              <img src="../../assets/images/integralCenter/list_code.svg" alt="活动二维码" class="code" slot="reference" />
            </el-popover>
            <span>{{ scope.row.activityName }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="礼品类型" prop="activityType">
        <template slot-scope="scope">
          <span>{{ scope.row.activityType == 9 ? "兑换实物" : "兑换优惠券" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="面值" prop="price">
        <!-- <template slot-scope="scope">
                </template> -->
      </el-table-column>

      <el-table-column label="所需积分" width="180">
        <template slot="header">
          <span>所需积分</span> &nbsp;
          <span class="open" v-show="!tableOpenAll" @click="tableOpenAll = true">展开全部</span>
          <span class="stop" v-show="tableOpenAll" @click="tableOpenAll = false">收起全部</span>
        </template>
        <template slot-scope="scope">
          <!-- <el-tooltip
            class="tooltip"
            effect="light"
            :content="'非会员:' + scope.row.memberLevelPointsListVOS[0].point"
            placement="top"
          > -->
          <div v-show="!tableOpenAll">
            <span>
              非会员:
              {{ scope.row.memberLevelPointsListVOS[0].point }}
            </span>
          </div>
          <!-- </el-tooltip> -->
          <div class="hoveTitleShowMore" v-show="tableOpenAll">
            <p v-if="scope.row.memberLevelPointsListVOS[0]">
              非会员:
              {{ scope.row.memberLevelPointsListVOS[0].point }}
            </p>
            <p v-if="scope.row.memberLevelPointsListVOS[1]">
              一星会员:
              {{ scope.row.memberLevelPointsListVOS[1].point }}
            </p>
            <p v-if="scope.row.memberLevelPointsListVOS[2]">
              二星会员:
              {{ scope.row.memberLevelPointsListVOS[2].point }}
            </p>
            <p v-if="scope.row.memberLevelPointsListVOS[3]">
              三星会员:
              {{ scope.row.memberLevelPointsListVOS[3].point }}
            </p>
            <p v-if="scope.row.memberLevelPointsListVOS[4]">
              四星会员:
              {{ scope.row.memberLevelPointsListVOS[4].point }}
            </p>
            <p v-if="scope.row.memberLevelPointsListVOS[5]">
              五星会员:
              {{ scope.row.memberLevelPointsListVOS[5].point }}
            </p>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="总数/已兑">
        <template slot-scope="scope">
          <span>{{ scope.row.num }}</span
          >/
          <span>{{ scope.row.sendNum }}</span>
        </template>
      </el-table-column>

      <el-table-column label="上下架时间" width="200">
        <template slot-scope="scope">
          <div class="activityTime">
            <span>上架: {{ scope.row.startTime }}</span>
            <span>下架: {{ scope.row.endTime }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="最后修改时间" prop="updateTime" width="200"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1"> <i class="y1"></i>待上架 </span>
          <span v-if="scope.row.status == 2"> <i class="y2"></i>已上架 </span>
          <span v-if="scope.row.status == 3"> <i class="y3"></i>已下架 </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <div class="editList">
            <span class="edit" v-if="scope.row.status == 1" v-zoom="{ from: pageName + '礼品列表', name: '编辑' }" @click="changeList(scope.row)"
              >编辑</span
            >
            <span class="edit" v-if="scope.row.status == 2 || scope.row.status == 3" @click="seeList(scope.row)">查看</span>
            <span class="count" v-if="scope.row.status == 1" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '上架' }"
              >上架</span
            >
            <span class="count" v-if="scope.row.status == 2" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '下架' }"
              >下架</span
            >
            <span class="count" v-if="scope.row.status == 3">-</span>
            <span class="delete" v-zoom="{ from: pageName + '礼品列表', name: '删除' }" @click="deleteById(scope.row)">删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="pageshow"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="10"
      background
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
      :total="totalNum"
    >
    </el-pagination>
    <!-- 编辑弹窗 -->
    <el-dialog title="详情" :visible.sync="dialogFormVis" width="45%">
      <el-form :model="amendForm" label-width="120px">
        <el-form-item label="礼品名称:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="礼品名称:" v-if="theSta == 0">
          <el-input v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="添加优惠券:" v-if="couponTxt.couponId">
          <div>
            <div class="couponContent">
              <div class="txtNum">
                ￥
                <span style="font-size: 36px; color: #fe4d45">{{ couponTxt.discount }}</span>
              </div>
              <div class="txtSize">
                满 {{ couponTxt.quota }} 元可使用 <br />
                {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
              </div>
              <p class="time">有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}</p>
              <!-- <div class="background"></div>
                <div class="btn">
                  <el-button @click="createActivity" type="primary" size="small"
                    >取消</el-button
                  >
                </div> -->
            </div>
            <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
            <p class="pContent">发行量：{{ couponTxt.num }}</p>
            <br />
            <p class="pContent">领券开始时间：{{ couponTxt.tekeBeginTime }}</p>
            <p class="pContent">领券结束时间：{{ couponTxt.takeEndTime }}</p>
            <br />
            <p class="pContent">限领规则：{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</p>
          </div>
        </el-form-item>
        <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9">
          <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input>&nbsp;元
        </el-form-item>
        <el-form-item label="礼品图片:" v-if="amendForm.activityType == 9">
          <img :src="amendForm.logo" style="width: 146px; height: 146px" />
          <p style="color: #fe4d45; font-size: 12px">
            建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG
          </p>
        </el-form-item>
        <el-form-item label="活动类型:">
          <el-radio-group v-model="amendForm.activityType" disabled>
            <el-radio :label="9">积分兑换实物</el-radio>
            <el-radio :label="10">积分兑换优惠券 </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="礼品价值:">
          <el-input v-model="amendForm.price" style="width: 180px" disabled></el-input>
          元
        </el-form-item>
        <el-form-item label="上下架时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.startTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
            <span> 至 </span>
            <el-date-picker
              disabled
              v-model="amendForm.endTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
          <span class="lastTime">
            活动持续
            <span style="color: #fe4d45">{{ timeDay }}</span> 天
          </span>
        </el-form-item>
        <el-form-item label="最后修改时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.updateTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="每人限兑次数:">
          <div class="limitBox">
            <el-input disabled v-model="amendForm.exchangeTimes" style="width: 180px"></el-input>
            次
            <p class="desc">
              <img
                src="@/assets/images/new_icon_reminder1.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
              />
              不填则默认不限
            </p>
          </div>
        </el-form-item>

        <el-form-item label="总份数:">
          <el-input disabled v-model="amendForm.quantityTotal" show-word-limit style="width: 136px"></el-input>&nbsp; 份
        </el-form-item>
        <el-form-item label="兑换所需积分:">
          <div class="isLevelSet">
            <template>
              <ul class="levelList" v-for="(item, index) in memberLevelList" :key="index">
                <li class="item" v-if="item.allow == true" style="width: 240px">
                  {{ item.name }}
                  <el-input disabled v-model="item.point" placeholder="请输入..." style="width: 80px"></el-input>
                  积分
                </li>
                <br />
              </ul>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 0">
          <el-input v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="theSta == 0">
        <el-button @click="dialogFormVis = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisB">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";

import {
  exchangeActivityList,
  deleteActivityList,
  updateActivityList,
  inquireActivity,
  changeActivity,
} from "@/api/paradiseAndTaskCommonController.js";

import { querydetail } from "@/api/integralCenter/couponWriteController.js";

export default {
  components: {
    inputForm,
  },
  data() {
    return {
      pageName: "忠诚度管理-积分商城",
      memberLevelList: [
        { value: "非会员", label: 0, point: "" },
        { value: "一星会员", label: 1, point: "" },
        { value: "二星会员", label: 2, point: "" },
        { value: "三星会员", label: 3, point: "" },
        { value: "四星会员", label: 4, point: "" },
        { value: "五星会员", label: 5, point: "" },
      ],
      talbeLoading: false,
      outerVisible: false,
      timeDay: 0, //活动持续天数
      theSta: 0,
      dialogFormVis: false,
      amendForm: {},
      couponTxt: {},
      // 表单配置项
      inputData: [
        {
          name: "礼品名称：",
          val: "activityName",
          placeholder: "请输入礼品名称",
        },
        {
          name: "礼品类型",
          val: "activityType",
          selectArr: [
            { label: "全部", id: null },
            { label: "兑换优惠券", id: 10 },
            { label: "兑换实物", id: 9 },
          ],
        },
        {
          name: "上架状态",
          val: "status",
          selectArr: [
            { label: "全部", id: null },
            { label: "待上架", id: 1 },
            { label: "已上架", id: 2 },
            { label: "已下架", id: 3 },
          ],
        },
      ],
      // 表格数据
      tableData: [],
      // 所需积分内容展开
      tableOpenAll: false,
      // 当前页
      currentPage: 1,
      pageshow: true,
      totalNum: 0,
      formList: {
        current: 1,
        size: 10,
      },
      status: 0,
      ids: null,
      qrcode: null,
    };
  },
  created() {
    this.prefixQue();
  },
  mounted() {
    this.getChangeList();
  },
  methods: {
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.getChangeList();
    },
    //获取列表数据
    getChangeList() {
      this.talbeLoading = true;
      exchangeActivityList(this.formList).then((res) => {
        this.tableData.forEach((item, index) => {
          var ref = "qrcode" + item.id;
          // console.log( this.$refs[ref])
          this.$refs[ref].innerHTML = "";
        });
        this.talbeLoading = false;
        this.tableData = res.data.records;
        this.totalNum = Number(res.data.total);
        this.prefixQue();
        // console.log(res.data, 222222);
        let mesUrl = "";
        this.tableData.forEach((item) => {
          if (item.activityType == 9) {
            mesUrl = "integralStore_exchange";
          } else if (item.activityType == 10) {
            mesUrl = "integralStore_discount";
          }
          item.idUrl = this.activityUrl + "/" + mesUrl + "?id=" + item.id + "&venderId=" + this.venderId;
          this.$nextTick(() => {
            let queryId = "qrcode" + item.id;
            this.qrcodeAll(item.idUrl, queryId);
            // console.log(queryId,22222222222222);
          });
        });
        // console.log(this.tableData, 222222);
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.amendForm.startTime.substring(0, 10);
      daysEnd = this.amendForm.endTime.substring(0, 10);
      if (this.amendForm.endTime != "" && this.amendForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.amendForm.endTime).getTime() - new Date(this.amendForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 表单查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.currentPage = 1;
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.getChangeList();

      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
    //修改
    changeList(row) {
      this.theSta = 0;
      this.dialogFormVis = true;
      let id = row.id;
      let activityType = 0;
      inquireActivity(id)
        .then((res) => {
          this.amendForm = res.data;
          // this.amendForm.memberLevelPointsDTOList.forEach((item, index) => {
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if ((item.allow = true)) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
        })
        .catch((res) => {});
    },
    //修改确定
    dialogFormVisB() {
      this.dialogFormVis = false;
      let obj = {
        activityName: this.amendForm.activityName,
        activityType: Number(this.amendForm.activityType),
        id: Number(this.amendForm.id),
        ruleDescription: this.amendForm.ruleDescription,
      };
      // console.log(row,111);
      // console.log(obj, 222);
      changeActivity(obj)
        .then((res) => {
          if (res && res.id) {
            this.getChangeList();
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
        })
        .catch((res) => {});
    },
    //查看
    seeList(row) {
      this.theSta = 1;
      let id = row.id;
      inquireActivity(id)
        .then((res) => {
          this.amendForm = res.data;
          // this.amendForm.memberLevelPointsDTOList.forEach((item, index) => {
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
        })
        .catch((res) => {});
      this.dialogFormVis = true;
    },

    amendTheList() {},
    //删除
    deleteById(row) {
      this.ids = Number(row.id);
      this.outerVisible = true;
    },
    handleDeleteTable() {
      let id = this.ids;
      deleteActivityList(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
          this.outerVisible = false;
        })
        .catch((res) => {});
    },
    //上下架
    updateList(row) {
      if (row.status == 1) {
        this.status = 2;
      } else if (row.status == 2) {
        this.status = 3;
      }
      let list = {
        id: Number(row.id),
        status: Number(this.status),
      };
      console.log(list);
      updateActivityList(list)
        .then((res) => {
          console.log(res);
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          // console.log(res, "res");
          // this.$message.error(res.message);
        });
    },
    // 分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.getChangeList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getChangeList();
    },
  },
};
</script>

<style scoped lang="scss">
.gift_list {
  box-sizing: border-box;
  padding: 20px 28px 30px;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .pContent {
    // display: block;
    float: left;
    width: 250px;
    color: #999999;
  }
  .couponContent {
    height: 130px;
    width: 260px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    position: relative;
    .txtNum {
      position: absolute;
      margin: 25px;
      width: 160px;
    }
    .txtSize {
      margin: 20px 0 0 140px;
    }
    .time {
      font-size: 12px;
      margin-left: 30px;
      color: #999999;
    }
    .btn {
      display: none;
      opacity: 0;
    }
  }
  .isLevelSet {
    // display: flex;
    .levelList {
      display: flex;
      flex-wrap: wrap;
      width: 450px;
      .item {
        text-align: right;
        margin-bottom: 16px;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .limitBox {
    .desc {
      font-size: 13px;
      color: #999;
      i {
        color: #fe8f8a;
        opacity: 0.8;
      }
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .open,
  .stop {
    color: #fe4d45;
    cursor: pointer;
  }
  .tooltip {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    width: 90%;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
  }
  .y1,
  .y2,
  .y3 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #cccccc;
  }
  .y2 {
    background-color: #7f85e9;
  }
  .y3 {
    background-color: #fe4d45;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #fe4d45;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
</style>
